import { ErrorDTO } from "groopit-js";

export enum SFErrorState {
  Unknown = "Unknown",
  NeedsAuthentication = "SalesforceNeedsAuthorization",
  Forbidden = "SalesforceNotAuthorized",
  SFError = "ExternalServiceFailure",
  MissingField = "ExternalServiceMissingField",
}

export const parseSFError = (error: ErrorDTO) => {
  if (error.error === "SalesforceNeedsAuthorization") {
    return SFErrorState.NeedsAuthentication;
  } else if (error.error === "SalesforceNotAuthorized") {
    return SFErrorState.Forbidden;
  } else if (error.error === "ExternalServiceFailure") {
    return SFErrorState.SFError;
  } else if (error.error === "ExternalServiceMissingField") {
    return SFErrorState.MissingField;
  } else {
    return SFErrorState.Unknown;
  }
};
